// Package imports
import { observer } from "mobx-react"
import { useEffect, useState } from "react"

// Project Imports
import SingleFamilyDetail from "./SingleFamilyDetail"
import SolutionStore from "modules/solution/store/SolutionStore"
import FamilyMemberTypeEnum from "modules/family-details-form/FamilymemberTypeEnum"
import CustomerCommunicationDetailsController from "./controller"
import AuthStore from "modules/login/store/AuthStore"
import { toJS } from "mobx"
import getCookie from "utils/journeyIdCookie/getJourneyId"
import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from "constants/Constants"
import { CustomCheckbox } from "components"
import CustomizationLoader from "components/ui/customization-loader/CustomizationLoader"
import isObjectEmpty from "utils/isObjectEmpty";


// import SprmDetailForm from "./SPRM/sprmDetailForm";

const CustomerCommunicationForm = ({
  // formController,
  hideModal,
  // submitData,
  successHandler,
  ...remainingProps
}) => {

  const [formController, setFormController] = useState({})


  useEffect(() => {
    let controller = new CustomerCommunicationDetailsController()
    let journeyData = toJS(AuthStore.journeyData);
    let journeyId = getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID);
    controller.setDefaults(journeyData, journeyId);

    setFormController(controller)
  }, [])


  const submitData = () => {
    formController.validate({ showErrors: true })
      .then(({ isValid }) => {
        let journeyId = getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID);
        if (isValid) {
          let formValues = formController.values()
          successHandler(formValues, journeyId)
          // SolutionStore.showOptinalEmail = false
        } else {
          console.log("Form errors are ", formController.errors())
        }
      });
  }
  const onchangeOptinalEmail = (e) => {
    SolutionStore.setOptinalEmail(e)
  }



  const memberFields = Object.keys(formController).length !== 0 ? formController?.get() : {}

  let familyMembeNameList = [];

  for (const key in memberFields) {
    familyMembeNameList.push(key)
  }

  // ! on click of close btn, show only 'SELF' Details  
  if (SolutionStore.isCloseBtnClicked) {
    familyMembeNameList = familyMembeNameList.filter(member => member === FamilyMemberTypeEnum.SELF || member === FamilyMemberTypeEnum.EMPLOYER)
  }
  let channel_code = document.cookie.split("; ").find((row) => row.startsWith("channel_code="))?.split("=")[1];


  let defaultBlinkTitle = {
    OA: "PFA & DM will be marked in the email being sent to customer",
    CBM: "PFA, BM & TM will be marked in the email being sent to customer",
    Direct: "RM & BM will be marked in the email being sent to customer",
    IM: "LIM & TM will be marked in the email being sent to customer"

  }
  console.log("SolutionStore.optinalEmail", toJS(SolutionStore.optinalEmail))

  return (
    <div className="bg-white modal-field-section pb-3 d-flex flex-column flex-grow-1 justify-content-between p-4">

      <div className="customer-communication-detail-container ">
        {familyMembeNameList.map((name) => {
          return <SingleFamilyDetail formController={formController} memberType={name} />
        })}
      </div>

      <div>
        {(SolutionStore.defaultEmails.length > 0 && !SolutionStore.isCloseBtnClicked ) &&
          <p className="blinking text-secondary font-weight-medium font-size-14 my-4 pt-lg-4">{defaultBlinkTitle[channel_code]}</p>
        }


      </div>
      <div className="row  mt-lg-3 mb-3">
        <div className="col-12 py-3 ">
          {SolutionStore.showOptinalEmail ?
            (!isObjectEmpty(SolutionStore.optinalEmail) &&
              <CustomCheckbox
                shape='rounded'
                title={SolutionStore.optinalEmail?.title}
                titleStyle='font-weight-medium  text-dark font-size-14 pl-2'
                isChecked={SolutionStore.optinalEmail?.is_selected}
                onChange={(e) => onchangeOptinalEmail(e)}
                mark='checkmark'
              />
            )
            :
            (!SolutionStore.isCloseBtnClicked &&
              <CustomizationLoader />
            )
          }
        </div>

        <div className="col-12 col-lg-7">
          <div className="row">
            <div className="col-12 col-lg-6 mb-3 mb-lg-0 pb-1 pb-lg-0 order-1 order-lg-1 pl-lg-1">
              <button
                className="btn btn-link btn-lg modal-cta-btn modal-cta-btn-link py-2 py-lg-1 font-size-14 font-weight-medium"
                // onClick={() => Utils.handleModalExit(remainingProps, hideModal)}
                onClick={hideModal}
              >
                Cancel
              </button>
            </div>
            <div className="col-12 col-lg-6 mb-3 mb-lg-0  order-0 order-lg-0 pr-lg-1">
              <button
                type="submit"
                disabled={SolutionStore.isCloseBtnClicked ? false : !SolutionStore.showOptinalEmail}
                className="btn btn-secondary btn-lg modal-cta-btn py-2 py-lg-1 font-size-14 font-weight-medium"
                onClick={submitData}
              >
                {SolutionStore.isCloseBtnClicked ? 'Save' : 'Preview'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default observer(CustomerCommunicationForm)
